import { render, staticRenderFns } from "./TrainingsTable.vue?vue&type=template&id=509a7865"
import script from "./TrainingsTable.vue?vue&type=script&lang=js"
export * from "./TrainingsTable.vue?vue&type=script&lang=js"
import style0 from "./TrainingsTable.vue?vue&type=style&index=0&id=509a7865&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports